<template>
  <v-dialog v-model="dialog" width="700" scrollable>
    <v-card>
      <v-card-title v-text="cardTitle" />
      <v-card-text>
        <dangerous-criteria-form :data="item" :is-edit="isEdit" @submit="submit" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import DangerousCriteriaForm from './DangerousCriteriaForm.vue';

export default {
  name: 'dangerous-criteria-dialog',
  components: { DangerousCriteriaForm },
  mixins: [DialogBusMixin],
  data: () => ({
    item: null,
    isEdit: false,
  }),
  computed: {
    hasItem() {
      return !!this.item;
    },
    cardTitle() {
      const titles = [
        'Новый критерий ОЯ',
        'Редактировать критерий ОЯ',
      ];
      return titles[Number(this.hasItem)];
    },
  },
  methods: {
    submit(i) {
      this.$emit('submit', i);
      this.dialog = false;
    },
    beforeOpen({ item }) {
      this.item = item;
      this.isEdit = !!this.item;
    },
  },
};
</script>

<style scoped>

</style>
